import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1e34e644"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=1e34e644&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports